import Icon from 'molecules/Icon';
import Image from 'molecules/Image';
import Link from 'molecules/Link';

import { hasArrayValues } from 'utils/array/arrays';
import { getAuthorPath } from 'utils/authors';

import type { IconIds } from 'molecules/Icon/types';
import type { FC } from 'react';

const AuthorCard: FC<AuthorReference> = props => {
  const { avatar, name, title, bio, socials } = props;
  // Null unless this author has a published profile page, so the byline under a
  // post never links to a 404.
  const authorPath = getAuthorPath(props);

  return (
    <div className="flex flex-col gap-5 rounded-lg border-[1.5px] border-solid border-primary-300 bg-primary-50 p-8 sm:flex-row sm:gap-6">
      {avatar?.url && (
        <div className="size-16 shrink-0 grow-0 basis-16 overflow-hidden rounded-lg border-2 border-solid border-primary-300">
          <Image
            url={avatar.url}
            alt={`Headshot of ${name}`}
            className="size-full"
            objectCover
            noFill={true}
            width={64}
            height={64}
            sizes="64px"
          />{' '}
        </div>
      )}
      <div className="flex w-full flex-col gap-4 sm:gap-4">
        <div className="flex flex-wrap items-center gap-6">
          {name &&
            (authorPath ? (
              <Link
                href={authorPath}
                className="text-display-xs font-semibold text-gray-900 underline-offset-4 hover:underline"
                enablePreview={false}
              >
                {name}
              </Link>
            ) : (
              <span className="text-display-xs font-semibold text-gray-900">{name}</span>
            ))}
          {title && <span className="text-lg font-semibold text-gray-700">{title}</span>}
        </div>
        {bio && <div className="text-lg text-gray-700">{bio}</div>}
        {hasArrayValues(socials) && (
          <div className="flex gap-4 text-gray-900">
            {socials.map(social => (
              <Link key={social.icon} href={social.link} aria-label="Social Link" enablePreview={false}>
                <Icon icon={social.icon as IconIds} size={24} />
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AuthorCard;
